var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g(_vm._b({staticClass:"iconfont-symbol",style:(_vm.svgStyle),attrs:{"aria-hidden":"true"}},'svg',_vm.$attrs,false),_vm.$listeners),[_c('use',{attrs:{"xlink:href":_vm.symbolId}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e9823a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/fonts/IconFont.vue
// module id = null
// module chunks = 